import { render, staticRenderFns } from "./fly_data_item.vue?vue&type=template&id=5ad02508&scoped=true&"
import script from "./fly_data_item.vue?vue&type=script&lang=js&"
export * from "./fly_data_item.vue?vue&type=script&lang=js&"
import style0 from "./fly_data_item.vue?vue&type=style&index=0&id=5ad02508&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad02508",
  null
  
)

export default component.exports